import {
    SignalInterface,
    SignalSharingFilters,
    signalSharingStore,
} from '../../../ng-services/social-trading/signal-sharing.store';
import { XTickChangeEntry, xTickStore } from '../../../ng-services/xtick.store';
// @ts-ignore
import { contrastColor } from 'contrast-color';
import { BaseExpandableTableComponent } from '../table-components/base-expandable-table.component';
import moment from 'moment';

export class SignalSharingTableComponent extends BaseExpandableTableComponent<SignalInterface, SignalSharingFilters> {
    constructor() {
        super(signalSharingStore.items);
    }

    getPriceChange(symbol: string, period: keyof XTickChangeEntry) {
        return xTickStore.getPriceChange(symbol, period);
    }

    getFormattedPriceChange(symbol: string, period: keyof XTickChangeEntry) {
        const change = xTickStore.getPriceChange(symbol, period);

        if (!change) {
            return null;
        }

        return `${change.toFixed(2)}%`;
    }

    valueClass(symbol: string, period: keyof XTickChangeEntry) {
        const value = this.getPriceChange(symbol, period);

        if (!value) {
            return null;
        }

        return {
            'is-positive': value > 0,
            'is-negative': value < 0,
        };
    }

    getCurrentPrice(symbol: string) {
        return xTickStore.price.get(symbol) || '';
    }

    getTextColor(bgColor: string) {
        return contrastColor({ bgColor });
    }

    getTimeInUtc(row: SignalInterface) {
        return moment(row.timestamp).utc();
    }

    getPost(signal: SignalInterface) {
        return signal.posts?.length ? signal.posts?.[0] : null;
    }

    getChannelName(signal: SignalInterface) {
        return this.getPost(signal)?.postable?.name ?? null;
    }

    getChannelUrl(signal: SignalInterface) {
        const post = this.getPost(signal);

        if (!post) {
            return null;
        }

        switch (post.entry) {
            case 'group':
                return `/group/${post.entry_id}`;
            case 'webinar':
                return `/webinar/${post.entry_id}`;
            case 'user':
                return `/${post.entry_id}`;
        }

        return null;
    }
}

angular.module('tradersyard').component('tySignalSharingTableComponent', {
    // language=HTML
    template: `
        <div is-uib>
            <table class="signal_sharing_table table table-condensed table-hover"  ng-class="{'has-sticky-header': $ctrl.hasStickyHeader}" mobx-autorun>
                <thead>
                <tr>
                    <th class="is-sticky col-symbol text-left">Symbol</th>
                    <th class="is-sticky col-signal-name text-left">Signal</th>
                    <th class="is-sticky col-signal-time-frame text-left">Period</th>
                    <th class="is-sticky col-channel">Community</th>
                    <th class="is-sticky col-trader">Trader</th>
                    <th class="is-sticky col-date text-left">Date</th>
                    <th class="is-sticky col-price text-right">Price</th>
                    <th class="is-sticky col-price-day text-right">1 Day</th>
                    <th class="is-sticky col-price-week text-right">7 Days</th>
                    <th class="is-sticky col-price-month text-right">30 Days</th>
                    <th class="is-sticky col-potential text-right">30 Days Potential</th>
                    <th class="is-sticky col-chart text-left" uib-tooltip="Last 100 days">Day chart</th>
                </tr>
                </thead>
                <tbody>
                <tr ng-if="$ctrl.isEmpty" class="signal_sharing_table__empty">
                    <td colspan="12">No signals found</td>
                </tr>
                <tr ng-repeat-start="row in $ctrl.data track by row.id"  mobx-autorun ng-click="$ctrl.toggle(row.id)">
                    <td class="col-symbol text-uppercase text-left">
                        <ty-symbol-link symbol="row.symbol"/>
                    </td>
                    <td class="col-signal-name text-left" tooltip-class="full-width-tooltip" uib-tooltip="{{row.signal_name}}" ng-style="{backgroundColor: row.color, color: $ctrl.getTextColor(row.color)}">{{row.signal_name}}</td>
                    <td class="col-signal-time-frame text-left">{{row.time_frame}}</td>
                    <td class="col-channel has-limited-width">
                        <a ng-href="{{$ctrl.getChannelUrl(row)}}" uib-tooltip="{{$ctrl.getChannelName(row)}}">{{$ctrl.getChannelName(row)}}</a>
                        <span ng-if="!$ctrl.getChannelName(row)">Public</span>
                    </td>
                    <td class="col-trader has-limited-width">
                        <a ng-href="/{{row.user.id}}" ng-if="row.user" uib-tooltip="{{row.user.name}}">{{row.user.name}}</a>
                    </td>
                    <td class="col-date text-left">{{::$ctrl.getTimeInUtc(row)|moment:'L LT'}}</td>
                    <td class="col-price text-right">{{$ctrl.getCurrentPrice(row.symbol) | number: 2}}</td>
                    <td class="col-price-day text-right" ng-class="$ctrl.valueClass(row.symbol, 'day')">{{$ctrl.getFormattedPriceChange(row.symbol, 'day')}}</td>
                    <td class="col-price-week text-right" ng-class="$ctrl.valueClass(row.symbol, 'week')">{{$ctrl.getFormattedPriceChange(row.symbol, 'week')}}</td>
                    <td class="col-price-month text-right" ng-class="$ctrl.valueClass(row.symbol, 'month')">{{$ctrl.getFormattedPriceChange(row.symbol, 'month')}}</td>
                    <td class="col-potential text-right">
                        <span ng-if="row.seasonal_potential">{{row.seasonal_potential | number: 2}}%</span>
                    </td>
                    <td class="col-chart">
                        <ty-mini-day-chart symbol="row.symbol" mobx-autorun/>
                    </td>
                </tr>
                <tr class="details" ng-if="!$ctrl.isCollapsed(row.id)" ng-repeat-end>
                    <td colspan="12">
                        <ty-signal-sharing-table-row-details-component signal="row"/>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    `,
    controller: SignalSharingTableComponent,
    bindings: {
        hasStickyHeader: '<',
    },
});
